import AutomaticFaultReporting from './component'

export default AutomaticFaultReporting
